export default __webpack_public_path__ + "static/media/co.616fbe2f.svg";